var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatarCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 0.600098C5.27998 0.600098 0.599976 5.2801 0.599976 11.0001C0.599976 16.7201 5.27998 21.4001 11 21.4001C16.72 21.4001 21.4 16.7201 21.4 11.0001C21.4 5.2801 16.72 0.600098 11 0.600098ZM11 3.7201C12.768 3.7201 14.12 5.0721 14.12 6.8401C14.12 8.6081 12.768 9.9601 11 9.9601C9.23197 9.9601 7.87997 8.6081 7.87997 6.8401C7.87997 5.0721 9.23197 3.7201 11 3.7201ZM11 18.4881C8.39997 18.4881 6.11198 17.1361 4.75998 15.1601C4.75998 13.0801 8.91998 11.9361 11 11.9361C13.08 11.9361 17.24 13.0801 17.24 15.1601C15.888 17.1361 13.6 18.4881 11 18.4881Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarCircle);
export default ForwardRef;